/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'
import { Schema$UserPickUserInfo } from '@interface/user-pick'
import AdvImg from '@components/AdvImg'

export interface UserPickProfileGroupProps {
  users: Schema$UserPickUserInfo[]
}

export const UserPickProfileGroup: React.FC<UserPickProfileGroupProps> = observer((props): React.ReactElement => {
  const { users = [] as Schema$UserPickUserInfo[] } = props
  let userList = [...users]
  if (_.size(userList) > 3) {
    userList = userList.splice(0, 3)
  }
  userList = userList.reverse()
  return (
    <div className="writer">
      <div className="user-profile">
        {userList.map(pickUser => (
          <div key={pickUser.userPromiseId} className={pickUser.isCustomProfileImg ? 'profile is-profile-custom' : 'profile'}>
            <div className="profile-img-wrap lhn32">
              {pickUser.isCustomProfileImg ?
                (<AdvImg src={pickUser.userProfileImg} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img" loading="lazy"/>)
                :
                (<AdvImg src={pickUser.userProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img" loading="lazy"/>)
              }
            </div>
          </div>
        ))}
      </div>
      <span className="num user-num">{_.size(users)}명</span>
    </div>
  )
})
